import { Link } from 'gatsby';
import React from 'react';
import {GetPageURL} from '../common/utils';
import { Container, Col } from 'react-bootstrap';
import './BottomDarkBanner.scss'
function BottomDarkBanner({module,GQLPage}) {
    console.log("GQLPAGE",GQLPage,module)
    const handleScroll = ()=>{
        const getId = document.getElementById("home-page-form")
        if (getId) {
            getId.scrollIntoView({behavior:"smooth",block: "start"}); 
        }
    }
   const openChat = () => {
    if (window && window.HubSpotConversations) {
      window.HubSpotConversations.widget.open();
    } else {
      console.log('chat not avaliable')
    }
  }
  return (
    <section className='section-btm-banner text-center'>
        <Container>
            <Col lg={10} xxl={8} className="m-auto">
                <h4>{module.Heading}</h4>
                <h2>{module.Title}</h2>
                {/* {module.CTA_Link && 
                <div className='d-flex justify-content-center'>
                    {GQLPage?.title === "Home"?
                    <button onClick={handleScroll} className='btn btn-pink'>{module?.CTA_Label}</button>   
                    : 
                    <Link className='btn btn-pink' to={GetPageURL(module.CTA_Link)}>
                        {module?.CTA_Label}
                    </Link>
                </div>
                } */}
                
                     <div className='d-flex justify-content-center'>
                       {(module?.CTA_Link && module?.CTA_Link !== null && module?.Custom_Link === null) ?
                          <Link className='btn btn-pink' to={GetPageURL(module.CTA_Link)}>
                             {module?.CTA_Label}
                        </Link> :
                        (module?.CTA_Link === null && module?.Custom_Link == "#chatbot") ?
                         <button
                            onClick={e => {
                                openChat()
                            }}
                           className="btn btn-pink"
                         >
                           <span> {module?.CTA_Label}</span>
                        </button> : ""
                       }
                     </div>
                
            </Col>
        </Container>
    </section>
  );
}

export default BottomDarkBanner;
